// Generated by design/game-sounds/build.mjs: how much louder than its file each clip plays, so all
// of them keep the ad's balance against each other (and the achievement sounds the balance they
// were approved at). The clinks are at gain 1 here: sound.ts sets each use's own gain.
export const LEVELS: Readonly<Record<string, number>> = { phoenix: 2.148, stamp: 1.733, sheet: 0.328, fuse: 0.315, flare: 0.079, 'clink-1100': 2.858, 'clink-2200': 2.246, 'clink-4400': 2.245, 'ablaze-fire': 1.008, 'ablaze-crackle': 0.912 }
/** The score's count-up tick, against tick.wav as typing plays it. */
export const COUNT_TICK = 1.120
/** Seconds of spark run that fuse.wav holds; sound.ts reshapes it for shorter runs. */
export const FUSE_RUN = 0.9
